import _ from "lodash";
import {jqGetJson} from "../helpers";

export function handleEditableSelectbox(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('[editable-selectbox]');
	} else {
		var $cont = $(selector + ' [editable-selectbox]');
	}

	$cont.each(function (idx) {
		let $sbox = $(this);

		$sbox.on('change', function (event) {
			var $el = $(this)

			var columnField = $el.attr('name')
			var newValue = $el.val()

			var changeUrl =
				detailLink.replace(9999999, $el.data('id')) +
				'?do=changeGridColumnValue&field=' +
				columnField +
				'&value=' +
				newValue;

			jqGetJson(changeUrl, function(data) {
				updateGridRowData(data)

				_.forEach(detailContentLoaderCallback, function(callback) {
					if (typeof callback === 'function') {
						callback()
					}
				})
			})
		});
	});

}

export function handleRemoteSelectbox(selector) {
	let $cont;
	if (typeof selector === 'object') {
		$cont = selector.find('[remote-selectbox]');
	} else {
		$cont = $(selector + ' [remote-selectbox]');
	}

	$cont.each(function (idx) {
		let $sbox = $(this);

		if (typeof $sbox.closest('form').attr('x-editable-form') !== 'undefined') {
			return;
		}

		let url = $sbox.data('source');
		let dataFields = $sbox.data('searchFields');
		let fields = [];
		if (dataFields) {
			fields = dataFields.split(',');
		}

		let ref = url.match(/\?fields=([a-zA-Z,]+)/);

		let valueField = 'id';
		let textField = 'name';

		if (ref[1]) {
			[valueField, textField] = ref[1].split(',');
		}

		let serverFiltering = $sbox.data('serverFiltering') ? $sbox.data('serverFiltering') : false;
		let defaultOpen = $sbox.data('defaultOpen') ? $sbox.data('defaultOpen') : false;

		let dataSource = new kendo.data.DataSource({
			serverFiltering: serverFiltering,
			transport: {
				read: {
					xhrFields: {
						withCredentials: true
					},
					url: url,
					dataType: "json"
				},
				parameterMap: function (data, action) {
					if(serverFiltering && action === 'read') {

						let dataNew = {}
						if (typeof data.filter !== 'undefined' && data.filter.filters.length) {
							let filterParams = data.filter.filters[0]
							if (filterParams.value.match(/^\#[0-9]+$/)) {
								dataNew['id'] = filterParams.value.replace('#', '');
								return $.param(dataNew)
							}

							let first = (filterParams.operator === 'contains' || filterParams.operator === 'endswith')
							let last = filterParams.operator === 'contains' || filterParams.operator === 'starstswith'
							dataNew[filterParams.field] = (first ? '*' : '') + filterParams.value + (last ? '*' : '')

							fields.forEach(field => {
								if (field === 'id') {
									dataNew[field] = filterParams.value;
								} else {
									dataNew[field] = (first ? '*' : '') + filterParams.value + (last ? '*' : '');
								}
							});
						}
						return $.param(dataNew)
					} else {
						return data;
					}
				},
				cache: true
			}
		});

		let dropdownParams = {
			filter: "contains",
			minLength: serverFiltering ? 3 : 1,
			autoBind: !serverFiltering,
			ignoreCase: !serverFiltering,
			dataTextField: textField,
			dataValueField: valueField,
			dataSource: dataSource,
			dataBound: function (e) {
        if (serverFiltering || defaultOpen) {
          ddl.open();
				}
			},
      open: function (e) {
        e.sender.list.closest('.k-popup').css('width', '340px');
      },
		};

		if ($sbox.data('empty') === true) {
			dropdownParams.optionLabel = '---';
		}

		let ddl = $sbox.kendoDropDownList(dropdownParams).data("kendoDropDownList");

		if ($sbox.data('default-value') && serverFiltering) {
			ddl.search('#' + $sbox.data('default-value'));
		}

		if ($sbox.data('default-value') && !serverFiltering) {
			ddl.value($sbox.data('default-value'));
		}
	});

}
